module.exports = __webpack_public_path__ + "static/media/verified-successfully.4795e78f.png";